import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ExpandableHtml } from 'app/components/shared/Expandable';
import Heading from 'app/components/shared/Heading';

export default class AboutTheAuthor extends React.PureComponent {
  render() {
    const noteText = this.props.authorNote;
    if (!noteText) return null;

    return (
      <div className="cp-about-the-author">
        <Heading tagName="h3" size="medium" variant>
          <FormattedMessage id="about_the_author" />
        </Heading>
        <ExpandableHtml
          htmlText={noteText}
          expandLinkHref="#author-description-read-more"
          dataKey="author-description-read-more-link"
          textKey="about_the_author"
        />
      </div>
    );
  }
}

AboutTheAuthor.propTypes = {
  authorNote: PropTypes.string
};
